import React from 'react';
import {Icon, Breadcrumbs,  Flex, Button, Form, Date, Submit, Textarea, Edit, List, Goals} from 'components';
import {over, shorten} from 'helpers';
import {goals} from 'store';

export function EditForm({ milestone, goal, modal }) {
  return (
    <Form initialValues={{ parent_id: goal?.id, ...milestone }} delay onSubmit={over(goals.dispatch.upsert, modal.close)}>
      <Flex className={['middle', 'justified']}>
        <Breadcrumbs>
          {goal.name}
          <b>{ milestone ? 'Edit' : 'New' } Milestone</b>
        </Breadcrumbs>
      </Flex>
      <List className="small-gutter">
        <Edit name="name" placeholder="Enter milestone.." required autoFocus />
        <Textarea name="note" placeholder="Enter note.." minRows={7} />
        <Edit type="number" name="target_value" label="Numerical Target" Suffix={Goals.NumberUnit} unitName="unit" />
        <Date name="target_date" label="Target Date" />
      </List>
      <Flex className={['right', 'medium-spacing', 'small']}>
        <Button className="borderless" onClick={modal.close}>Cancel</Button>
        <Submit>{['Save', 'Saving..']}</Submit>
      </Flex>
    </Form>
  );
}

//<Layout.Header justified container="small">
//  <h2>{ milestone ? milestone.name : 'Add Milestone' }</h2>
//  <Video.Trigger src={config.videos.milestones} />
//  <Button.Back className="pull-right" to={`/goals/${goal_id}/milestones/`} />
//  <Submit>
//    {[ 'Save', 'Saving..', milestone && 'Saved' ]}
//  </Submit>
//</Layout.Header>
